module.exports = __webpack_public_path__ + "img/finished-project-participant.c2ac018e.png";